export const desktopMenu = () => {
  const header = document.querySelector('.site-header');

  //after user scrolls 100px add class of minimize to .site-header
  window.addEventListener('scroll', () => {
    if (window.scrollY > 100) {
      header.classList.add('minimize', 'is-scrolling', 'is-scrolled');
    } else {
      header.classList.remove('minimize', 'is-scrolling', 'is-scrolled');
    }
  });

  // find .site-navigation > ul > li > a[href="#"] and add click event to prevent default
  const parentMenuItems = header.querySelectorAll('.menu > li > a[href="#"]');
  parentMenuItems.forEach((menuItem) => {
    menuItem.addEventListener('click', (e) => {
      e.preventDefault();

      menuItem.parentElement.classList.toggle('is-active');
      // remove is-active from siblings
      menuItems.forEach((menuItem) => {
        if (menuItem !== e.target) {
          menuItem.parentElement.classList.remove('is-active');
        }
      });
    });
  });

  // desktop events
  const menuItems = header.querySelectorAll('.menu > li > a');
  const logo = header.querySelector('.site-branding a');
  const search = header.querySelector('.site-search button');

  const removeActiveState = () => {
    menuItems.forEach((menuItem) => {
      menuItem.parentElement.classList.remove('is-active');
    });
  };

  const handleMouseEnter = (e) => {
    removeActiveState();
    e.target.parentElement.classList.add('is-active');
  };

  const addDesktopEvents = () => {
    // on mouse enter, add is-active, remove from siblings
    menuItems.forEach((menuItem) => {
      menuItem.addEventListener('mouseenter', handleMouseEnter);
    });

    // on other buttons mouse leave, remove is-active
    header.addEventListener('mouseleave', removeActiveState);
    logo.addEventListener('mouseenter', removeActiveState);
    //search.addEventListener('mouseenter', removeActiveState);
  };

  const removeDesktopEvents = () => {
    menuItems.forEach((menuItem) => {
      menuItem.removeEventListener('mouseenter', handleMouseEnter);
    });
    header.removeEventListener('mouseleave', removeActiveState);
    logo.removeEventListener('mouseenter', removeActiveState);
    //search.removeEventListener('mouseenter', removeActiveState);
  };

  const mediaQuery = window.matchMedia('(min-width: 1080px)');
  if (mediaQuery.matches) {
    addDesktopEvents();
  }

  mediaQuery.addEventListener('change', (e) => {
    if (e.matches) {
      addDesktopEvents();
    } else {
      removeDesktopEvents();
    }
  });
};
